// Auto-generated by scripts/generate-hook-exports.cjs - DO NOT EDIT
import { token } from "@/lib/contract-interactions/hooks";

export const {
  useAllowance,
  useApprove,
  useBalanceOf,
  useBurn,
  useBurnFrom,
  useDecimals,
  useDecreaseAllowance,
  useIncreaseAllowance,
  useInitialize,
  useMint,
  useName,
  useOwner,
  useRenounceOwnership,
  useSymbol,
  useTotalSupply,
  useTransfer,
  useTransferFrom,
  useTransferOwnership,
} = token;
